import React, { PropsWithChildren } from "react"
import { Tooltip } from "react-tooltip"
import { ButtonStyle } from "../models/ButtonStyle"
import { FeatureService } from "../services/FeatureService"

export { ButtonStyle } from "../models/ButtonStyle"

interface ButtonProps {
    label: string
    style?: ButtonStyle
    onClick?: () => void
    id?: string
    disabled?: boolean
    className?: string
    tooltip?: string
    loading?: boolean
    tooltipAtDisabled?: boolean
}

export class Button extends React.Component<PropsWithChildren<ButtonProps>, unknown> {
    onClick = () => {
        if (!this.props.onClick) {
            return
        }
        this.props.onClick.call(this)
    }

    render() {
        const style = this.props.style || ButtonStyle.PRIMARY
        const className = this.props.className || ""
        let tooltip = undefined
        if (this.props.tooltip) {
            if (FeatureService.isFeatureActive("DEMO") && this.props.tooltipAtDisabled) {
                tooltip = { "data-tooltip-html": "custom", "data-tooltip-id": `${this.props.id}-tooltip` }
            } else {
                tooltip = { "data-tooltip-html": `${this.props.tooltip}`, "data-tooltip-id": `${this.props.id}` }
            }
        }
        const loading = this.props.loading || false
        let tooltipId = null
        if (FeatureService.isFeatureActive("DEMO")) {
            tooltipId = `${this.props.id}-tooltip`
        } else {
            tooltipId = this.props.id
        }
        return (
            <>
                <button
                    id={this.props.id}
                    className={`btn btn-${style} ${className} ${loading ? "pulse" : ""} ${
                        FeatureService.isFeatureActive("DEMO") && this.props.tooltipAtDisabled ? "tooltip-button" : ""
                    }`}
                    onClick={this.onClick}
                    disabled={!!this.props.disabled || loading}
                    {...tooltip}
                >
                    {FeatureService.isFeatureActive("DEMO") && this.props.tooltipAtDisabled && <span className="tooltip-button-overlay" {...tooltip}></span>}
                    {this.props.label}
                    {this.props.children}
                </button>
                {tooltip && (
                    <Tooltip id={tooltipId} place="top" variant="dark" float={true}>
                        {this.props.tooltip}
                    </Tooltip>
                )}
            </>
        )
    }
}
